/* eslint-disable max-len */

// Иконка мероприятий в меню
export const EventsIcon = () => {
  const renderContent = () => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M17.5 3.75C17.5 3.05964 16.9404 2.5 16.25 2.5H13.75V1.25H12.5V2.5H7.5V1.25H6.25V2.5H3.75C3.05964 2.5 2.5 3.05964 2.5 3.75V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H6.25V16.25H3.75V3.75H6.25V5H7.5V3.75H12.5V5H13.75V3.75H16.25V7.5H17.5V3.75ZM13.125 9.375L14.7188 12.4625L18.125 12.9563L15.625 15.3562L16.2437 18.75L13.1938 17.15L10 18.75L10.625 15.3562L8.125 12.9563L11.625 12.4625L13.125 9.375Z' fill='currentColor' />
    </svg>
  );

  return renderContent();
};
